import { provideHttpClient } from '@angular/common/http';
import { EnvironmentProviders, Provider } from '@angular/core';
import { WINDOW_PROVIDERS } from '@portal-core/util/window.provider';

/**
 * App-wide root providers for portal-status (formerly CoreModule, consumed via importProvidersFrom).
 * Spread into the bootstrapApplication providers in main.ts.
 */
export function provideCore(): (Provider | EnvironmentProviders)[] {
  return [
    // ApiService injects WINDOW.
    ...WINDOW_PROVIDERS,
    provideHttpClient()
  ];
}
